module.exports = __webpack_public_path__ + "static/media/icon-chevon-left.e6f8ce63.svg";